module.exports = __webpack_public_path__ + "media/images/landing__seasonPrize__prize2-8f52dd954fad962897a456e61426ef45.jpg";